import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/portal-logo-web.png")